import React, { useEffect } from "react";
import { Form, Grid, Message } from "@arco-design/web-react";
import { useRef, useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { ManageApis } from "../../../../common/APIS/ManageApis";
import {
  getLocalStorage,
  handleApiError,
  removeLeadingSpace,
  sanitizeEmail,
} from "../../../../common/Utils/Utils";
import { useAlert } from "../../../../common/Context/AlertContext";
import { useLoader } from "../../../../common/Context/LoaderContext";
import InputField from "../../../InputField/InputField";
import { forgotPasswordEmailField } from "./forgotPasswordEmailField";
import notify from "../../../../common/Utils/toastService";
import { HARDCODED_PRODUCTKEY } from "../../../../common/constant";
function ForgotEmailVerificationForm() {
  const formRef = useRef();
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { setLoading } = useLoader();
  const token = getLocalStorage("token");

  const handleInputChange = (value, field) => {
    const valueWithoutLeadingSpace = removeLeadingSpace(value);
    if (field === "email") {
      const sanitizedEmailValue = sanitizeEmail(valueWithoutLeadingSpace);
      form.setFieldValue(field, sanitizedEmailValue);
    } else {
      form.setFieldValue(field, value);
    }
  };

  const handleSubmit = async () => {
    const isValid = await form.validate();
    if (!isValid) {
      console.log("Validation failed. Please check the form.");
      return;
    }
    try {
      setLoading(true);
      const fields = form.getFieldsValue();

      const reqBody = {
        ...fields,
        productKey: HARDCODED_PRODUCTKEY,
      };

      const response = await ManageApis(
        "post",
        window.forgotPassword,
        reqBody,
        token
      );
      const { status_code, message, response_data } = response || {};
      const { status, message: responseMessage = "" } =
        response?.response_data || {};
      if (response?.status_code === 200 || response?.message === "Success") {
        // Message.success(responseMessage);
        notify.success(responseMessage);
        navigate("/login");
      } else {
        handleApiError(status, message, status_code, showAlert);
      }
    } catch (error) {
      console.error("API call failed:", error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="w-100 position-relative">
        <div
          className="p-3 p-md-0  mx-auto registerMain loginMain"
          style={{
            height: "400px",
            minWidth: "460px",
            alignContent: "center",
          }}
        >
          <h3 className="font_22 fw_600">Enter Email</h3>
          <p className="font_12 font_500 text_gray10 mb-4">
            Please enter your registered email address to receive a password
            reset link
          </p>
          <div className="customForm">
            <Form form={form} autoComplete="off" onSubmit={handleSubmit}>
              <Form.Item>
                <div className="customInput">
                  <Grid.Row style={{ alignItems: "center" }} gutter={12}>
                    {forgotPasswordEmailField(form).map((field) => (
                      <InputField
                        inputStyle={{ height: "42px" }}
                        key={field.field}
                        value={form.getFieldValue(field.field)}
                        onChange={(value) =>
                          handleInputChange(value, field.field)
                        } // Use custom onChange handler
                        {...field}
                      />
                    ))}
                  </Grid.Row>
                </div>
                <div className="position-relative">
                  <button
                    type="submit"
                    style={{ height: "35px", fontSize: "13px" }}
                    className="w-100 btn1 btn-primary1 rounded fw_500 px-4 mt-3"
                  >
                    Submit
                  </button>
                </div>
              </Form.Item>
            </Form>
            <div className="mt-2 text-center">
              <span
                onClick={() => navigate("/login")}
                className="text-primary cursor-pointer"
              >
                Back to login
              </span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ForgotEmailVerificationForm;
